import { httpsCallable, type Functions as FirebaseFunctions } from 'firebase/functions';

const RESYNC_TIMEOUT_MS = 300000; // 5 minutes

export class CallableApiService {
  constructor(private readonly functions: FirebaseFunctions) {}

  public async resyncUserSource(userSourceId: string, options?: { url?: string }): Promise<void> {
    const callable = httpsCallable(this.functions, 'resyncUserSource', { timeout: RESYNC_TIMEOUT_MS });
    await callable({ userSourceId, url: options?.url });
  }
}
